import { memo } from 'react';
import type { SuperAvatarProps } from './SuperAvatar.types';
import { useSuperAvatar } from './useSuperAvatar';

function SuperAvatarBase(props: SuperAvatarProps) {
  const { name, src, className, ariaLabel } = props;
  const vm = useSuperAvatar(props);

  return (
    <span role="img" aria-label={ariaLabel ?? name} className={className} style={vm.style}>
      {vm.showImage ? (
        <img
          src={src}
          alt=""
          onError={vm.handleImageError}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        vm.initials
      )}
      {vm.channelDotStyle && <span aria-hidden style={vm.channelDotStyle} />}
    </span>
  );
}

export const SuperAvatar = memo(SuperAvatarBase);
